import { CaseDocument } from "pwapi";

export type BillingProperty =
  | "indigent"
  | "self_pay_with_attestation"
  | "self_pay"
  | "";

export function getBillingProperty(values: {
  indigent?: boolean;
  self_pay_with_attestation?: boolean;
  self_pay?: boolean;
}): BillingProperty {
  if (values.indigent) return "indigent";
  if (values.self_pay_with_attestation) return "self_pay_with_attestation";
  if (values.self_pay) return "self_pay";
  return "";
}

export function reconcileBillingDocuments(
  billingProperty: BillingProperty,
  documents: CaseDocument.category[]
): CaseDocument.category[] {
  let next = [...documents];
  if (billingProperty === "self_pay_with_attestation") {
    if (!next.includes(CaseDocument.category.SELF_PAY_ATTESTATION)) {
      next.push(CaseDocument.category.SELF_PAY_ATTESTATION);
    }
  } else {
    next = next.filter((c) => c !== CaseDocument.category.SELF_PAY_ATTESTATION);
  }
  if (billingProperty === "indigent") {
    if (
      !next.includes(CaseDocument.category.INDIGENT_PATIENT_AGREEMENT_NOTICE)
    ) {
      next.push(CaseDocument.category.INDIGENT_PATIENT_AGREEMENT_NOTICE);
    }
  } else {
    next = next.filter(
      (c) => c !== CaseDocument.category.INDIGENT_PATIENT_AGREEMENT_NOTICE
    );
  }
  return next;
}
